/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ApiCatalogService, ApiFileInfo, ApiFolderInfo } from '../shared/services/api-catalog/api-catalog.service';

@Component({
  selector: 'app-api-catalog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './api-catalog.component.html',
  styleUrl: './api-catalog.component.scss'
})
export class ApiCatalogComponent implements OnInit {
  apiFolders: ApiFolderInfo[] = [];
  expandedFolders: Set<string> = new Set();
  loading = false;
  error: string | null = null;

  constructor(
    private apiCatalogService: ApiCatalogService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadApiFiles();
  }

  loadApiFiles() {
    this.loading = true;
    this.error = null;

    this.apiCatalogService.getApiFolders().subscribe({
      next: (folders) => {
        this.apiFolders = folders;
        this.loading = false;
      },
      error: (error) => {
        this.error = 'Failed to load API files';
        this.loading = false;
        console.error('Error loading API files:', error);
      }
    });
  }

  toggleFolder(folderName: string) {
    if (this.expandedFolders.has(folderName)) {
      this.expandedFolders.delete(folderName);
    } else {
      this.expandedFolders.add(folderName);
    }
  }

  isFolderExpanded(folderName: string): boolean {
    return this.expandedFolders.has(folderName);
  }

  openApiViewer(api: ApiFileInfo) {
      this.router.navigate(['/api-viewer', api.apiId]);    
  }
}
